/*
 * --------------------------------------
 * Copyright (c) 2022 BetterCapital.US
 * --------------------------------------
 */
import { SET_DRAWER_STATE } from "../actions/actionTypes";

const initialState = {
  drawerState: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_DRAWER_STATE:
      return {
        ...state,
        drawerState: action.payload
      };
    default:
      return state;
  }
}
